import styled from "styled-components";
import * as Rebass from "@rebass/forms/styled-components";

export const Input = styled(Rebass.Input)`
  &:disabled {
    background-color: WhiteSmoke;
    color: gray;
  }
`;
